import { render, staticRenderFns } from "./financeiro-imposto-prestador.vue?vue&type=template&id=7609b772&scoped=true"
import script from "./financeiro-imposto-prestador.vue?vue&type=script&lang=ts"
export * from "./financeiro-imposto-prestador.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-imposto-prestador.vue?vue&type=style&index=0&id=7609b772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7609b772",
  null
  
)

export default component.exports